// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + {"91":"SmartBannerFullScreen","260":"FavouritesUiDynamicBuyerInfoModal"}[chunkId] + ".twh." + {"91":"7a8d3bed","260":"72c28b65"}[chunkId] + ".css";
};